import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { useColor, useContrastColor } from '../../packages/kiti/components/theme/_hooks/colors'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import { useOpenEditProcessModal } from '../../utils/routes/modals/modalsActions'
import Button from '../../packages/kiti/components/actions/Button'
import Circle from '../../packages/kiti/components/shapes/Circle'
import DropdownLink from '../../components/navigation/DropdownLink'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Loading from '../../packages/kiti/components/helpers/Loading'
import Panel from '../../packages/kiti/components/structure/Panel'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'
import { Absolute, Relative } from '../../packages/kiti/components/helpers/Position'
import EmojiPreview from '../../components/form/EmojiPreview'
import { useRemoveProcess } from './edit/_requests/removeProcesses'

const ProcessesItem = ({ screen }) => {
  const { t } = useTranslation()
  const navigate = useNavigation()
  const openEditProcessModal = useOpenEditProcessModal()
  const [removeProcess, { loading }] = useRemoveProcess()
  const contrastColor = useContrastColor(screen?.data?.configuration?.color)
  const canCreateScreen = useSessionPermission('setupScreen')
  const bgColor = useColor('light1') + '80'

  const onSelect = () => {
    navigate(`/processes/kanban/${screen.id}`)
  }

  if (loading) return <Loading />

  return (
    <Col>
      <Relative zIndex="auto">
        <Panel height={14} borderColor="light2" noPadding>
          <Grid
            justify="space-between"
            align="center"
            bgColor={screen?.data?.configuration?.color || COLORS.primary}
            style={{ borderRadius: '0.5rem 0.5rem 0 0' }}
          >
            <Col paddingH={1} paddingV={2.5}>
              <Absolute zIndex="auto">
                <Circle color="white" size={4}>
                  <EmojiPreview unified={screen?.data?.configuration?.icon || '1f3e2'} size={32} />
                </Circle>
              </Absolute>
            </Col>

            <Col flex={1} />
            <Col padding={0.5}>
              {canCreateScreen && (
                <DropdownLink
                  options={[
                    {
                      label: t('edit'),
                      icon: 'BsPencil',
                      onClick: () => openEditProcessModal({ id: screen.id })
                    },
                    {
                      label: t('clone'),
                      icon: 'BsLayers',
                      onClick: () => openEditProcessModal({ id: screen.id, isCloning: true })
                    },
                    {
                      label: t('remove'),
                      color: COLORS.lightRed,
                      icon: 'BsTrash',
                      onClick: () => removeProcess(screen.id)
                    }
                  ]}
                  fromRight
                  actionContent={<Icon name="BsThreeDotsVertical" color={contrastColor} size={1} />}
                />
              )}
            </Col>
          </Grid>
          <Col paddingH={1} paddingV={1.5} flex={1} bgColor={bgColor}>
            <Separator weight={4} />
            <Text size="small" bold color="dark2">
              {screen.name}
            </Text>
            <Separator weight={2} />
            <Col flex={1} />
            <Button transparent bold size="xxsmall" color="dark3" onClick={onSelect}>
              {t('select')}
            </Button>
          </Col>
        </Panel>
      </Relative>
    </Col>
  )
}

export default ProcessesItem
